import React, { useState } from "react";
import { useApp } from "../context/AppContext";
import { useToast } from "../components/Toast";
import { useI18n } from "../context/I18nContext";

export default function ShoppingList() {
  const { state, actions } = useApp();
  const { t } = useI18n();
  const [input, setInput] = useState("");
  const { toast } = useToast();

  const list = state.shoppingList;
  const checked = list.filter((item) => item.checked);
  const unchecked = list.filter((item) => !item.checked);

  const handleAdd = async () => {
    const value = input.trim();
    if (!value) return;
    const result = await actions.addToShopping(value);
    if (result.success) {
      setInput("");
      toast(`"${value}" ${t("ingredientAdded")}`, "success");
    } else {
      toast(result.error, "error");
    }
  };

  const handleClearChecked = async () => {
    if (!checked.length) return;
    await actions.clearChecked();
    toast(t("purchasedCleared"));
  };

  return (
    <div>
      <div className="page-header">
        <h1>🛒 {t("shopping")}</h1>
        <p>{t("shoppingIntro")}</p>
      </div>

      <div className="shopping-list">
        <div className="shopping-header">
          <h2>
            {t("list")}{" "}
            <span style={{ fontSize: 14, color: "var(--text3)", fontWeight: 400 }}>
              ({unchecked.length} {t("waiting")}, {checked.length} {t("completed")})
            </span>
          </h2>
          {checked.length > 0 && (
            <button className="btn btn-ghost btn-sm" onClick={handleClearChecked}>
              {t("clearCompleted")}
            </button>
          )}
        </div>

        {list.length === 0 ? (
          <div className="empty-state">
            <div className="empty-icon">🛒</div>
            <h3>{t("emptyList")}</h3>
            <p>{t("shoppingEmptyHint")}</p>
          </div>
        ) : (
          <>
            {unchecked.map((item) => (
              <ShoppingItem
                key={item.id}
                item={item}
                onToggle={() => actions.toggleShopping(item.id)}
                onDelete={() => actions.removeShopping(item.id)}
              />
            ))}

            {checked.length > 0 && (
              <>
                <div className="shopping-section-title">{t("purchased")}</div>
                {checked.map((item) => (
                  <ShoppingItem
                    key={item.id}
                    item={item}
                    onToggle={() => actions.toggleShopping(item.id)}
                    onDelete={() => actions.removeShopping(item.id)}
                  />
                ))}
              </>
            )}
          </>
        )}

        <div className="shopping-add-row">
          <input
            type="text"
            placeholder={t("addNewIngredient")}
            value={input}
            onChange={(event) => setInput(event.target.value)}
            onKeyDown={(event) => event.key === "Enter" && handleAdd()}
          />
          <button className="btn btn-green" onClick={handleAdd}>+ {t("add")}</button>
        </div>
      </div>
    </div>
  );
}

function ShoppingItem({ item, onToggle, onDelete }) {
  const { t } = useI18n();
  return (
    <div className={`shopping-item ${item.checked ? "checked" : ""}`}>
      <button className={`shopping-check ${item.checked ? "done" : ""}`} onClick={onToggle}>
        {item.checked && <span style={{ color: "white", fontSize: 12 }}>✓</span>}
      </button>
      <span className="shopping-item-name">{item.name}</span>
      <button className="shopping-delete" onClick={onDelete} title={t("delete")}>{t("delete")}</button>
    </div>
  );
}
